import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './age-by-single-year-of-age.reducer';

export const AgeBySingleYearOfAgeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const ageBySingleYearOfAgeEntity = useAppSelector(state => state.ageBySingleYearOfAge.entity);
  const loading = useAppSelector(state => state.ageBySingleYearOfAge.loading);
  const updating = useAppSelector(state => state.ageBySingleYearOfAge.updating);
  const updateSuccess = useAppSelector(state => state.ageBySingleYearOfAge.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/age-by-single-year-of-age${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalValue !== undefined && typeof values.totalValue !== 'number') {
      values.totalValue = Number(values.totalValue);
    }
    if (values.aged4AndUnder !== undefined && typeof values.aged4AndUnder !== 'number') {
      values.aged4AndUnder = Number(values.aged4AndUnder);
    }
    if (values.underOneYear !== undefined && typeof values.underOneYear !== 'number') {
      values.underOneYear = Number(values.underOneYear);
    }
    if (values.aged1Year !== undefined && typeof values.aged1Year !== 'number') {
      values.aged1Year = Number(values.aged1Year);
    }
    if (values.aged2Years !== undefined && typeof values.aged2Years !== 'number') {
      values.aged2Years = Number(values.aged2Years);
    }
    if (values.aged3Years !== undefined && typeof values.aged3Years !== 'number') {
      values.aged3Years = Number(values.aged3Years);
    }
    if (values.aged4Years !== undefined && typeof values.aged4Years !== 'number') {
      values.aged4Years = Number(values.aged4Years);
    }
    if (values.aged5To9Years !== undefined && typeof values.aged5To9Years !== 'number') {
      values.aged5To9Years = Number(values.aged5To9Years);
    }
    if (values.aged10To15Years !== undefined && typeof values.aged10To15Years !== 'number') {
      values.aged10To15Years = Number(values.aged10To15Years);
    }
    if (values.aged16To19Years !== undefined && typeof values.aged16To19Years !== 'number') {
      values.aged16To19Years = Number(values.aged16To19Years);
    }
    if (values.aged20To24Years !== undefined && typeof values.aged20To24Years !== 'number') {
      values.aged20To24Years = Number(values.aged20To24Years);
    }
    if (values.aged25To34Years !== undefined && typeof values.aged25To34Years !== 'number') {
      values.aged25To34Years = Number(values.aged25To34Years);
    }
    if (values.aged35To49Years !== undefined && typeof values.aged35To49Years !== 'number') {
      values.aged35To49Years = Number(values.aged35To49Years);
    }
    if (values.aged50To64Years !== undefined && typeof values.aged50To64Years !== 'number') {
      values.aged50To64Years = Number(values.aged50To64Years);
    }
    if (values.aged65To74Years !== undefined && typeof values.aged65To74Years !== 'number') {
      values.aged65To74Years = Number(values.aged65To74Years);
    }
    if (values.aged75To84Years !== undefined && typeof values.aged75To84Years !== 'number') {
      values.aged75To84Years = Number(values.aged75To84Years);
    }
    if (values.aged85AndOver !== undefined && typeof values.aged85AndOver !== 'number') {
      values.aged85AndOver = Number(values.aged85AndOver);
    }
    if (values.aged100AndOver !== undefined && typeof values.aged100AndOver !== 'number') {
      values.aged100AndOver = Number(values.aged100AndOver);
    }

    const entity = {
      ...ageBySingleYearOfAgeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...ageBySingleYearOfAgeEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.ageBySingleYearOfAge.home.createOrEditLabel" data-cy="AgeBySingleYearOfAgeCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.home.createOrEditLabel">
              Create or edit a AgeBySingleYearOfAge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="age-by-single-year-of-age-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.geographicLevel')}
                id="age-by-single-year-of-age-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.date')}
                id="age-by-single-year-of-age-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.geography')}
                id="age-by-single-year-of-age-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.geographyCode')}
                id="age-by-single-year-of-age-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.totalValue')}
                id="age-by-single-year-of-age-totalValue"
                name="totalValue"
                data-cy="totalValue"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged4AndUnder')}
                id="age-by-single-year-of-age-aged4AndUnder"
                name="aged4AndUnder"
                data-cy="aged4AndUnder"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.underOneYear')}
                id="age-by-single-year-of-age-underOneYear"
                name="underOneYear"
                data-cy="underOneYear"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged1Year')}
                id="age-by-single-year-of-age-aged1Year"
                name="aged1Year"
                data-cy="aged1Year"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged2Years')}
                id="age-by-single-year-of-age-aged2Years"
                name="aged2Years"
                data-cy="aged2Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged3Years')}
                id="age-by-single-year-of-age-aged3Years"
                name="aged3Years"
                data-cy="aged3Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged4Years')}
                id="age-by-single-year-of-age-aged4Years"
                name="aged4Years"
                data-cy="aged4Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged5To9Years')}
                id="age-by-single-year-of-age-aged5To9Years"
                name="aged5To9Years"
                data-cy="aged5To9Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged10To15Years')}
                id="age-by-single-year-of-age-aged10To15Years"
                name="aged10To15Years"
                data-cy="aged10To15Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged16To19Years')}
                id="age-by-single-year-of-age-aged16To19Years"
                name="aged16To19Years"
                data-cy="aged16To19Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged20To24Years')}
                id="age-by-single-year-of-age-aged20To24Years"
                name="aged20To24Years"
                data-cy="aged20To24Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged25To34Years')}
                id="age-by-single-year-of-age-aged25To34Years"
                name="aged25To34Years"
                data-cy="aged25To34Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged35To49Years')}
                id="age-by-single-year-of-age-aged35To49Years"
                name="aged35To49Years"
                data-cy="aged35To49Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged50To64Years')}
                id="age-by-single-year-of-age-aged50To64Years"
                name="aged50To64Years"
                data-cy="aged50To64Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged65To74Years')}
                id="age-by-single-year-of-age-aged65To74Years"
                name="aged65To74Years"
                data-cy="aged65To74Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged75To84Years')}
                id="age-by-single-year-of-age-aged75To84Years"
                name="aged75To84Years"
                data-cy="aged75To84Years"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged85AndOver')}
                id="age-by-single-year-of-age-aged85AndOver"
                name="aged85AndOver"
                data-cy="aged85AndOver"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ageBySingleYearOfAge.aged100AndOver')}
                id="age-by-single-year-of-age-aged100AndOver"
                name="aged100AndOver"
                data-cy="aged100AndOver"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/age-by-single-year-of-age" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AgeBySingleYearOfAgeUpdate;
